import React, { useEffect, useState } from 'react';
import Project from '../Project/Project';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Projects = () => {
    const [projects, setProjects] = useState([])

    useEffect(() => {
        fetch("./projects.json")
            .then(res => res.json())
            .then(data => setProjects(data))
    }, [])

    useEffect(() => {
        AOS.init({
            duration: 600,
        })
    }, [])

    return (
        <div id="projects" style={{ background: "#2B3436" }}>
            <div className="container">
                <h1
                    data-aos="fade-right"
                    className="text-center text-white pt-5 pb-3 section-border">My Project</h1>

                <div className="row row-cols-1 row-cols-md-3 g-4 pb-5">
                    {
                        projects.map(project => <Project
                            key={project.id}
                            project={project}
                        ></Project>)
                    }
                </div>
            </div>
        </div>
    );
};

export default Projects;